import React from "react";

/**
 * Shared horizontal gutter for the whole app. Keeps the navbar logo, page
 * titles, hero form, and the profile/notification cluster on the same left and
 * right lines across every breakpoint. Use <PageContainer> to wrap page content;
 * use PAGE_GUTTER_CLASS directly where wrapping isn't practical (navbar row, hero).
 */
export const PAGE_GUTTER_CLASS =
  "mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-10 xl:px-16";

/** Slightly wider side padding — for landing sections like the banner/FAQ. */
export const PAGE_GUTTER_INSET_CLASS =
  "mx-auto w-full max-w-7xl px-6 sm:px-10 lg:px-16 xl:px-24";

interface PageContainerProps {
  children: React.ReactNode;
  className?: string;
  variant?: "default" | "inset";
}

const PageContainer: React.FC<PageContainerProps> = ({
  children,
  className = "",
  variant = "default",
}) => {
  const gutter =
    variant === "inset" ? PAGE_GUTTER_INSET_CLASS : PAGE_GUTTER_CLASS;
  return <div className={`${gutter} ${className}`}>{children}</div>;
};

export default PageContainer;
